import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, OnChanges } from '@angular/core';
import { MantenedorService } from 'src/app/services/mantenedor.service';
import { UnificadoService } from 'src/app/services/unificado.service';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractFormGroupDirective } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { ContactService } from 'src/app/services/contact.service';
import { GeneralesService } from 'src/app/services/generales.service';
import { ProcesoMatriculaService } from 'src/app/services/procesomatricula.service';
import { Contact } from 'src/app/models/contact.model';
import { AddUpdProcesoInput, UpdProcesoInput } from 'src/app/models/addUpdProcesoInput.model';
import { Lookup } from 'src/app/models/lookup.model';
import { ApiCallResult, ApiCallResultSimulacion } from 'src/app/models/apicallresult.model';
import { NotaService } from 'src/app/services/nota.service';
import { ProcesoMatricula } from 'src/app/models/procesomatricula.model';
import { OptionSet } from 'src/app/models/optionSet.model';

import { ToastrService } from 'ngx-toastr';
import { FaseService } from 'src/app/services/fase.service';
import { Subscription } from 'rxjs';
import { ProcesosActivosService } from 'src/app/services/procesosactivos.service';
import { Router } from '@angular/router';
import { GlobalVariable } from 'src/app/config/service.config';



declare var $: any;

@Component({
  selector: 'app-simular',
  templateUrl: './simular.component.html',
  styleUrls: ['./simular.component.css']
})
export class SimularComponent implements OnInit, OnDestroy, OnChanges {

  @Output() Fase: EventEmitter<string> = new EventEmitter();
  @Input() IdProcesoActual: string = ""
  @Input() changeCarreraCount: number = 0;
  @Input() faseActual: string;
  @Input() ultimafase: number;
  @Output() Panelcrm: EventEmitter<any> = new EventEmitter();

  // Form
  SimuladorForm: FormGroup;
  FaseSubcribe: Subscription;
  panel: any = null;

  userData: any = null;
  notasData: any = null;
  notasPSUData: any = null;
  progress: boolean = false;
  procesoSimulacion: any = null;
  pagoAlContado: any = false;
  enviando: boolean = false;
  todoCargado: boolean = false;
  errorAlSimular: boolean = false;
  errorViaIngreso: boolean = false;
  user: any = null
  showBtnSimular: boolean = false

  // Loading states
  result_institucion: ApiCallResult = new ApiCallResult([])
  result_sede: ApiCallResult = new ApiCallResult([])
  result_areaDeEstudio: ApiCallResult = new ApiCallResult([])
  result_carrera: ApiCallResult = new ApiCallResult([])
  result_jornada: ApiCallResult = new ApiCallResult([])
  result_modalidad: ApiCallResult = new ApiCallResult([])
  result_obtieneTipoIngreso: ApiCallResult = new ApiCallResult(null);
  result_copagoMatriculayArancel: ApiCallResultSimulacion | any = new ApiCallResultSimulacion(null);
  result_dcto: ApiCallResult | any = new ApiCallResult(null);
  result_becaMineduc: ApiCallResultSimulacion = new ApiCallResultSimulacion(null);
  result_becaPSU: ApiCallResultSimulacion | any = new ApiCallResultSimulacion(null);
  result_becaSantoTomas: ApiCallResultSimulacion | any = new ApiCallResultSimulacion(null);
  result_becaCAE: ApiCallResultSimulacion | any = new ApiCallResultSimulacion(null);
  result_pagoContado: any = {}
  result_pagoAlDia: any = {
    data: {
      AbonoMatricula: 0,
      AbonoColegiatura: 0,
      MatriculaDoc: 0,
      ColegDoc: 0
    }, loading: false, success: false, loaded: false
  };
  result_pagoColegiaturaPlazo: any = {
    data: {
      MontoSemestre1: 0,
      MontoSemestre2: 0
    }, loading: false, success: false, loaded: false
  };
  simulacionPrevia: Boolean = false

  proceso: ProcesoMatricula;
  
  // Utils
  MetodoFirma: any;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private mantenedor: MantenedorService,
    private servicioUnificado: UnificadoService,
    private auths: AuthService,
    private generalesService: GeneralesService,
    private procesoMatriculaService: ProcesoMatriculaService,
    private contactservice: ContactService,
    private notaService: NotaService,
    public faseService: FaseService,
    private procesosActivosService: ProcesosActivosService,
    public alerts: ToastrService
  ) {
    this.SimuladorForm = fb.group({
      Institucion: ['', [Validators.required]],
      Sede: ['', [Validators.required]],
      Area: ['', [Validators.required]],
      Carrera: ['', [Validators.required]],
      Modalidad: [],
      TipoPlan: [],
      ViaAdmision: [],
      Direccion: ['', []],
      TipoPrograma: ['', [Validators.required]],
      Jornada: ['', [Validators.required]],
      UsarMontoCAE: [false],
      PagoAlContado: [this.pagoAlContado],
      MontoAlDia: [0],
      DiasPagoSem1: [1],
      DiasPagoSem2: [1],
      MontoAUtilizar: []
    });

    this.SimuladorForm.controls.Direccion.disable();
    this.SimuladorForm.controls.Modalidad.disable();
    this.SimuladorForm.controls.TipoPlan.disable();
    this.SimuladorForm.controls.ViaAdmision.disable();

    console.log("[SIMULACIÓN] proceso", this.proceso)
    // // Adecuaciones
    this.SimuladorForm.controls.Institucion.disable();
    this.SimuladorForm.controls.Sede.disable();
    this.SimuladorForm.controls.Area.disable();
    this.SimuladorForm.controls.Jornada.disable();
    this.SimuladorForm.controls.TipoPrograma.disable();
    this.SimuladorForm.controls.Carrera.disable();
    this.SimuladorForm.controls.Modalidad.disable();
    this.SimuladorForm.controls.TipoPlan.disable();
    this.SimuladorForm.controls.ViaAdmision.disable();

    this.MetodoFirma = false
    var MetodoFirma = this.servicioUnificado.getMetodoFirma().subscribe(
      (data: any) => { 
        this.MetodoFirma = data.ECertActivo
      },
      (error) => { 
        this.MetodoFirma = false
      }
    );

    this.loadInitialData();
  }
  ngOnDestroy(): void {

    if (this.FaseSubcribe != null && this.FaseSubcribe != undefined) {
      this.FaseSubcribe.unsubscribe();
    }
  }

  ngOnInit(): void {
    // $(document).ready(function() {
    //   // alert('I am Called From jQuery Simulación');
    //   $('#exampleModal').modal('show');
    // });
  }

  ngOnChanges(changes: any) {
    console.log('[SIMULACION] ngOnChanges', changes)
    if (changes.changeCarreraCount) {
      console.log(changes.changeCarreraCount.currentValue);
      const _changeCarreraCount = changes.changeCarreraCount.currentValue;
      if (_changeCarreraCount > 0) {
        this.LimpiarCargas(true);

        setTimeout(() => {
          try { $('html, body').animate({ scrollTop: $('#selectCarrera').offset().top }, 'slow'); } catch { }
        }, 500);
      }
    }
  }


  /********* LOADS *********/
  async loadInitialData() {
    // Get Panel
    this.panel = await this.generalesService.getPanel().toPromise();
    this.Panelcrm.emit(this.panel);
    // Institución
    await this.loadInstitucion();

    // Jornada
    this.result_jornada.data = [
      { Id: 'D', Nombre: 'Diurno' },
      { Id: 'V', Nombre: 'Vespertino' },
    ]

    // Listener
    //this.crearListenerFormulario();

    // Datos usuario conectado
    await this.loadUserData();

    // Proceso existente
    console.log("[SIMULACIÓN] this.IdProcesoActual", this.IdProcesoActual, this.IdProcesoActual?.length)
    if (this.IdProcesoActual && this.IdProcesoActual.length > 0) {
      await this.loadProceso();
    }
  }

  cleanSelects(step: number) {
    this.SimuladorForm.get("Modalidad").setValue('');
    this.SimuladorForm.get("TipoPlan").setValue('');
    this.SimuladorForm.get("ViaAdmision").setValue('');

    if (step <= 4) {
      this.result_carrera.data = [];
      this.SimuladorForm.get("Carrera").setValue('');
    }

    if (step <= 3) {
      // this.result_jornada.data = [];
      this.SimuladorForm.get("Jornada").setValue('');
    }

    if (step <= 2) {
      this.SimuladorForm.get("Area").setValue('');
      this.result_areaDeEstudio.data = [];
    }

    if (step <= 1) {
      this.result_sede.data = [];
      this.SimuladorForm.get("Sede").setValue('');
      this.SimuladorForm.get("Direccion").setValue('');
    }
  }

  async loadInstitucion() {
    this.result_institucion.loading = true
    const data: any = await this.mantenedor.getInstitucion2(
      this.panel.PeriodoAdm.Id
    ).toPromise().catch(error => {
      console.log(`[SIMULACIÓN] [Error!] Mantenedor de Institucion : ${error}`);
      this.result_institucion.loading = false
    })
    this.result_institucion.data = data.Result;
    this.result_institucion.loading = false;
    // //TODO: borrar
    // var idInstitucion='ed579863-ae0e-e511-80c4-00155dfd1662';
    // this.SimuladorForm.controls.Institucion.setValue(idInstitucion);
    // this.SimuladorForm.controls.Institucion.disable();
    // var idSede='d16b6206-5511-eb11-80cf-005056bbdae9'
    // this.SimuladorForm.controls.Sede.setValue(idSede);
    // this.SimuladorForm.controls.Sede.disable();
    // var jornada='V';
    // this.SimuladorForm.controls.Jornada.setValue(jornada);
    // this.SimuladorForm.controls.Jornada.disable();
    // var idcarrera='c1847681-5e11-eb11-80cf-005056bbdae9';
    // this.SimuladorForm.controls.Carrera.setValue(idcarrera);
    // this.SimuladorForm.controls.Carrera.disable();

    // var idArea='eeae86fd-5d3d-e511-80ca-00505682b492';
    // var tipoprograma='P';
    // this.SimuladorForm.controls.Area.setValue(idArea);
    // this.SimuladorForm.controls.TipoPrograma.setValue(tipoprograma);
    // // TODO: Termino de borrar

  }

  async loadProceso() {
    // Load proceso

    this.procesoSimulacion = {}
    this.procesoSimulacion.Id = this.IdProcesoActual
    this.FaseSubcribe = this.faseService.fase$.subscribe(async value => {

      if (value == '3') {
        this.alerts.info('Cargando información del Alumno', 'Fase  3 Datos de Carrera Convocada');
        const proceso: ProcesoMatricula = await this.procesoMatriculaService.GetProceso(this.IdProcesoActual).toPromise();
        this.proceso = proceso;
        console.log("[CARRERA CONVOCADA] proceso", proceso)



        this.panel.Institucion = new Lookup(proceso.Institucion?.Id, proceso.Institucion?.Name);
        this.panel.Sede = new Lookup(proceso.Sede?.Id, proceso.Sede?.Name);
        this.panel.Carrera = new Lookup(proceso.Carrera?.Id, proceso.Carrera?.Name);
        this.panel.Jornada = new OptionSet((proceso.Jornada?.Value == "1" ? "D" : "V"), proceso.Jornada?.Text);
        this.panel.TipoIngreso = new Lookup(proceso.TipoIngreso?.Id, proceso.TipoIngreso?.Name);
        //this.panel.ViaAdmision

        console.log('[SIMULACIÓN] proceso existente', proceso)

        this.loadDataFromProceso()
        // const simulacionPrevia = proceso.Institucion !== null && proceso.Institucion !== undefined
        // console.log('[CARRERA CONVOCADA] simulacionPrevia', simulacionPrevia)
        // if (simulacionPrevia) {
        //   // this.loadDataFromProceso()
        // } else {
        //   this.loadDataFromCentralizada()
        // }
      }
    });

  }

  async loadDataFromProceso() {
    const proceso = this.proceso
    console.log('[CARRERA CONVOCADA] LOAD FROM PROCESO', proceso)

    // Institución
    console.log('[CARRERA CONVOCADA] LOAD Institución')
    this.SimuladorForm.get('Institucion').setValue(proceso.Institucion.Id);
    await this.ChangeInstitucion({ target: { value: proceso.Institucion.Id } });

    // Sede
    console.log('[CARRERA CONVOCADA] LOAD Sede')
    this.SimuladorForm.get('Sede').setValue(proceso.Sede.Id);
    await this.ChangeSede({ target: { value: proceso.Sede.Id } });

    // Area
    console.log('[CARRERA CONVOCADA] Seteando Area', proceso.Area.Id)
    this.SimuladorForm.get('Area').setValue(proceso.Area.Id);
    console.log('[CARRERA CONVOCADA] Area Seteada', proceso.Area.Id)
    await this.ChangeArea({ target: { value: proceso.Area.Id } });

    // Jornada
    console.log('[CARRERA CONVOCADA] data.Jornada', proceso.Jornada)
    this.SimuladorForm.get('Jornada').setValue(proceso.Jornada.Value === "1" ? "D" : "V");
    await this.ChangeJornada({ target: { value: proceso.Jornada.Value } });

    // Carrera
    console.log('[CARRERA CONVOCADA] data.Carrera', proceso.Carrera)
    this.SimuladorForm.get('Carrera').setValue(proceso.Carrera.Id);

    if (proceso.FasePortal.Value == '3') {
      this.Simular()
      return
    }
    // this.result_institucion.loaded = true; this.result_institucion.success = true;
    // this.result_sede.loaded = true; this.result_sede.success = true;
    // this.result_areaDeEstudio.loaded = true; this.result_areaDeEstudio.success = true;
    // this.result_carrera.loaded = true; this.result_carrera.success = true;
    // this.result_jornada.loaded = true; this.result_jornada.success = true;

    // Matrícula
    this.result_copagoMatriculayArancel.data = {}
    this.result_copagoMatriculayArancel.data.RetornoDesdeApi = [{}]
    this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].ValorAnualMatriculaListaOriginal = proceso.CopagoMatricula;
    this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].ValorSemestreMatriculaLista = proceso.CopagoMatricula1;
    this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].ValorSemestreDosMatriculaLista = proceso.CopagoMatricula2;

    // Dcto Matricula
    this.result_dcto.data = {}
    this.result_dcto.data.RetornoDesdeApi = [{ DATA: [{ porcentajeDescuento: -1 }] }]
    // this.result_dcto.data.RetornoDesdeApi.DATA = [{}]
    this.result_dcto.data.RetornoDesdeApi[0].DATA[0].porcentajeDescuento = proceso.ProcentajeDesMatricula;
    this.result_dcto.ValorDcto = proceso.ValorDescMatricula;
    this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].ValorAnualMatriculaLista = proceso.CopagoMatriculaTotal;

    // Arancel
    this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].ValorAnualArancelLista = proceso.CopagoArenceles;
    this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].ValorSemestreArancelLista = proceso.CopagoAranceles1;
    this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].ValorSemestreDosArancelLista = proceso.CopagoAranceles2;

    // Mineduc
    this.result_becaMineduc.data = {}
    this.result_becaMineduc.data.ListBecaMineduc = [{}]
    this.result_becaMineduc.data.ListBecaMineduc[0].Monto = proceso.MontoBecaAsignable;
    this.result_becaMineduc.data.ListBecaMineduc[0].Monto = proceso.MontoBeca;
    this.result_becaMineduc.totalAcumulado = proceso.ValorColegAPagar;
    this.result_becaMineduc.tieneDatosValidos = proceso.MontoBeca > 0

    // PSU
    this.result_becaPSU.porcentaje = proceso.Porcentaje;
    this.result_becaPSU.valorDcto = proceso.ValorDescuento;
    this.result_becaPSU.totalAcumulado = proceso.ValorColegAPagar1;
    this.result_becaPSU.tieneDatosValidos = proceso.Porcentaje > 0

    // // Sto Tomas
    // payload.PorcentajeDescuentoBecode = "";
    // payload.ValorDescuentoBecode = "";
    // payload.ValorColegAPagar2 = "";


    // CAE
    this.result_becaCAE.MontoCAE = proceso.MontoCae;
    this.SimuladorForm.get('UsarMontoCAE').setValue(proceso.DeseaUsarCredito);
    this.result_becaCAE.totalAcumulado = proceso.ColegaDoc;
    this.SimuladorForm.get('MontoAUtilizar').setValue(proceso.MontoAUtilizar);
    this.result_becaCAE.tieneDatosValidos = proceso.MontoCae > 0

    this.result_pagoContado.MatriculaADoc = proceso.MontoMatriculaPP;
    this.result_pagoContado.MontoDcto = proceso.DescuentoProntoPago;
    this.result_pagoContado.totalAcumulado = proceso.MontoColegiaturaPP;

    this.pagoAlContado = false; // TODO: Dummy
    // if (!this.pagoAlContado) {

    //   // Pago al dia
    //   this.SimuladorForm.get('MontoAlDia').setValue(proceso.MontoAlDia);
    //   this.result_pagoAlDia.FechaDocumento = proceso.FechaDocumento;
    //   this.result_pagoAlDia.data.AbonoMatricula = proceso.AbonoMatricula;
    //   this.result_pagoAlDia.data.AbonoColegiatura = proceso.AbonoColegiatura;
    //   this.result_pagoAlDia.data.MatriculaDoc = proceso.MatriculaADoc;
    //   this.result_pagoAlDia.data.ColegDoc = proceso.ColegaDoc1;

    //   // Pago Colegiatura Plazo
    //   if (!this.result_pagoColegiaturaPlazo.data) {
    //     this.result_pagoColegiaturaPlazo.data = {}
    //   }
    //   this.result_pagoColegiaturaPlazo.data.MontoSemestre1 = proceso.Total1Sem;
    //   this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].cuotasCopagoArancelSemestre1 = proceso.Cuotas1;
    //   this.result_pagoColegiaturaPlazo.data.MontoSemestre2 = proceso.Total2Sem;
    //   this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].cuotasCopagoArancelSemestre2 = proceso.Cuotas2;
    //   this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].FechaVctoCopagoArancelSemestre = proceso.FechaPago1;
    //   this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].FechaVctoCopagoArancelSegundoSemestre = proceso.FechaPago2;

    //   this.result_copagoMatriculayArancel.diasPagoSem1 = [5, 15, 25];
    //   this.result_copagoMatriculayArancel.diasPagoSem2 = [5, 15, 25];

    //   // TODO: Fill this data
    //   this.SimuladorForm.get("DiasPagoSem1").setValue((new Date(proceso.FechaPago1)).getDate())
    //   this.SimuladorForm.get("DiasPagoSem2").setValue((new Date(proceso.FechaPago2)).getDate())
    // }


    // CAE
    this.result_becaCAE.MontoCAE = proceso.MontoCae;
    this.SimuladorForm.get('UsarMontoCAE').setValue(proceso.DeseaUsarCredito);
    this.result_becaCAE.totalAcumulado = proceso.ColegaDoc;
    this.SimuladorForm.get('MontoAUtilizar').setValue(proceso.MontoAUtilizar);

    this.result_pagoContado.MatriculaADoc = proceso.MontoMatriculaPP;
    this.result_pagoContado.MontoDcto = proceso.DescuentoProntoPago;
    this.result_pagoContado.totalAcumulado = proceso.MontoColegiaturaPP;

    this.pagoAlContado = false; // TODO: Dummy
    if (!this.pagoAlContado) {

      // Pago al dia
      this.SimuladorForm.get('MontoAlDia').setValue(proceso.MontoAlDia);
      this.result_pagoAlDia.FechaDocumento = proceso.FechaDocumento;
      this.result_pagoAlDia.data.AbonoMatricula = proceso.AbonoMatricula;
      this.result_pagoAlDia.data.AbonoColegiatura = proceso.AbonoColegiatura;
      console.log('[ARANCEL DE CARRERA] ', proceso.MatriculaADoc)
      this.result_pagoAlDia.data.MatriculaDoc = proceso.MatriculaADoc;
      this.result_pagoAlDia.data.ColegDoc = proceso.ColegaDoc1;

      // Pago Colegiatura Plazo
      if (!this.result_pagoColegiaturaPlazo.data) {
        this.result_pagoColegiaturaPlazo.data = {}
      }
      this.result_pagoColegiaturaPlazo.data.MontoSemestre1 = proceso.Total1Sem;
      this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].cuotasCopagoArancelSemestre1 = proceso.Cuotas1;
      this.result_pagoColegiaturaPlazo.data.MontoSemestre2 = proceso.Total2Sem;
      this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].cuotasCopagoArancelSemestre2 = proceso.Cuotas2;
      this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].FechaVctoCopagoArancelSemestre = proceso.FechaPago1;
      this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].FechaVctoCopagoArancelSegundoSemestre = proceso.FechaPago2;

      const diaPago = 25
      this.result_copagoMatriculayArancel.diasPagoSem1 = [diaPago];
      this.result_copagoMatriculayArancel.diasPagoSem2 = [diaPago];
      // TODO: Fill this data
      this.SimuladorForm.get("DiasPagoSem1").setValue(diaPago)
      this.SimuladorForm.get("DiasPagoSem2").setValue(diaPago)
    }



    // this.result_obtieneTipoIngreso.loaded = true; this.result_obtieneTipoIngreso.success = true;
    this.result_copagoMatriculayArancel.loaded = true; this.result_copagoMatriculayArancel.success = true;
    this.result_dcto.loaded = true; this.result_dcto.success = true;
    this.result_becaMineduc.loaded = true; this.result_becaMineduc.success = true;
    this.result_becaPSU.loaded = true; this.result_becaPSU.success = true;
    // this.result_becaSantoTomas.loaded = true; this.result_becaSantoTomas.success = true;
    this.result_becaCAE.loaded = true; this.result_becaCAE.success = true;
    this.result_pagoAlDia.loaded = true; this.result_pagoAlDia.success = true;
    this.result_pagoColegiaturaPlazo.loaded = true; this.result_pagoColegiaturaPlazo.success = true;
    console.log('[SIMULACIÓN] ProcesoMatricula', proceso);

    if (Number.parseInt(this.faseActual) < this.ultimafase) {
      this.Fase.emit('4');
      this.faseService.fase$.emit('4');
    }
  }

  // async loadDataFromCentralizada() {
  //   //TODO: Dummy data. Debería ir el rut del usuario conectado
  //   this.user.Rut = "20802758"
  //   this.user.Dv = "1"

  //   const proceso = this.proceso
  //   console.log('[CARRERA CONVOCADA] LOAD FROM CENTRALIZADA', proceso)
  //   // Adecuaciones
  //   const existePostulacionResponse: any = await this.contactservice.ExistePostulacionRut(this.user.Rut, this.user.Dv).toPromise()
  //   /********* *********/

  //   console.log('[CARRERA CONVOCADA] existePostulacionResponse (TOMAR SOLO estadoPost: 24)', existePostulacionResponse)
  //   const postulacionCentralizada24 = existePostulacionResponse.filter(p => p.estadoPost === 24)
  //   console.log('[CARRERA CONVOCADA] postulacionCentralizada24', postulacionCentralizada24)
  //   if (postulacionCentralizada24.length > 0) {
  //     console.log('[CARRERA CONVOCADA] postulacionCentralizada24[0]', postulacionCentralizada24[0])
  //     const postulacionCentralizada = postulacionCentralizada24[0]

  //     // TODO: De dónde obtengo el Nombre de estos campos y para qué se utiliza el panel?
  //     this.panel.Institucion = new Lookup(postulacionCentralizada.idInstitucion, proceso.Institucion?.Name);
  //     this.panel.Sede = new Lookup(postulacionCentralizada.idSede, proceso.Sede?.Name);
  //     this.panel.Carrera = new Lookup(postulacionCentralizada.idCarrera, proceso.Carrera?.Name);
  //     this.panel.Jornada = new OptionSet((postulacionCentralizada.jornada), proceso.Jornada?.Text);
  //     this.panel.TipoIngreso = new Lookup(proceso.TipoIngreso?.Id, proceso.TipoIngreso?.Name);
  //     //this.panel.ViaAdmision

  //     console.log('[CARRERA CONVOCADA] simulación existente', proceso)

  //     // Adecuaciones
  //     this.SimuladorForm.controls.Institucion.disable();
  //     this.SimuladorForm.controls.Sede.disable();
  //     this.SimuladorForm.controls.Area.disable();
  //     this.SimuladorForm.controls.Jornada.disable();
  //     this.SimuladorForm.controls.TipoPrograma.disable();
  //     this.SimuladorForm.controls.Carrera.disable();
  //     this.SimuladorForm.controls.Modalidad.disable();
  //     this.SimuladorForm.controls.TipoPlan.disable();
  //     this.SimuladorForm.controls.ViaAdmision.disable();

  //     // Institución
  //     console.log('[SIMULACIÓN] Seteando Institución', postulacionCentralizada.idInstitucion)
  //     this.SimuladorForm.get('Institucion').setValue(postulacionCentralizada.idInstitucion);
  //     await this.ChangeInstitucion({ target: { value: postulacionCentralizada.idInstitucion } });

  //     // Sede
  //     console.log('[SIMULACIÓN] Seteando Sede', postulacionCentralizada.idSede)
  //     this.SimuladorForm.get('Sede').setValue(postulacionCentralizada.idSede);
  //     await this.ChangeSede({ target: { value: postulacionCentralizada.idSede } });

  //     // Area
  //     console.log('[SIMULACIÓN] Seteando Area', postulacionCentralizada.area)
  //     this.SimuladorForm.get('Area').setValue(postulacionCentralizada.area);
  //     console.log('[SIMULACIÓN] Area Seteada', postulacionCentralizada.area)
  //     await this.ChangeArea({ target: { value: postulacionCentralizada.area } });

  //     // Jornada
  //     console.log('[SIMULACIÓN] data.Jornada', postulacionCentralizada.jornada)
  //     // this.SimuladorForm.get('Jornada').setValue(proceso.Jornada.Value === "1" ? "D" : "V");
  //     this.SimuladorForm.get('Jornada').setValue(postulacionCentralizada.jornada);
  //     await this.ChangeJornada({ target: { value: postulacionCentralizada.jornada } });

  //     // tipoPrograma
  //     console.log('[SIMULACIÓN] data.tipoPrograma', postulacionCentralizada.tipoPrograma)
  //     this.SimuladorForm.get('TipoPrograma').setValue(postulacionCentralizada.tipoPrograma);
  //     await this.ChangeJornada({ target: { value: postulacionCentralizada.tipoPrograma } });

  //     // Carrera
  //     console.log('[SIMULACIÓN] data.Carrera', postulacionCentralizada.idCarrera)
  //     this.SimuladorForm.get('Carrera').setValue(postulacionCentralizada.idCarrera);
  //     await this.ChangeCarrera({ target: { value: postulacionCentralizada.idCarrera } });

  //     // TODO: Fijar bien "TipoPlan"
  //     // tipoPrograma: this.SimuladorForm.get("TipoPlan").value == "Regular" ? "PR" : "PC",
  //     // this.SimuladorForm.controls.TipoPlan.setValue(modalidadTipoPlan[1]);
  //     // Tiene que ver con el Área

  //     this.Simular()
  //     /********* *********/
  //   }
  // }

  async loadUserData() {
    // const user = this.auths.GetUserToken();
    this.user = this.auths.GetUserToken();
    const user = this.user
    if (user !== null) {
      this.contactservice.GetContactFull(user.primarysid, this.IdProcesoActual).subscribe(
        (data: Contact) => {
          // console.log('[SIMULACIÓN] userdata', data)
          this.userData = data

          this.notaService.GetNotas(this.userData.IdContacto).subscribe(
            (dataNotas: any) => {
              this.notasData = dataNotas;
            }
          )

          this.notaService.GetPSU(this.userData.IdContacto).subscribe(
            (dataNotasPSU: any) => {
              // console.log('[SIMULACIÓN] NOTAS PSU', dataNotasPSU)
              this.notasPSUData = dataNotasPSU;
            }
          )
        })
    }
  }
  /********* LOADS *********/


  /********* FUNCTIONS *********/
  // daysInMonth(month, year) {
  //   return new Date(year, month, 0).getDate();
  // }
  daysInMonth(date: any) {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    console.log('[SIMULACIÓN] daysInMonth', date, year, month)
    return new Date(year, month, 0).getDate();
  }
  /********* FUNCTIONS *********/


  /********* SELECTS CHANGES *********/
  async ChangeInstitucion(event: any) {
    this.cleanSelects(1);
    const id = event.target.value;
    if (id === '') { return; }
    this.result_sede.loading = true
    const data: any = await this.mantenedor.getSede2(
      this.panel.PeriodoAdm.Id,
      id).toPromise().catch(error => { console.log('[SIMULACIÓN] Change institución Error: ', error); this.result_sede.loading = false; })
    this.result_sede.data = data.Result;
    this.result_sede.loading = false
  }

  async ChangeSede(event: any) {
    this.cleanSelects(2);
    const id = event.target.value;
    if (id === '') { return; }
    var sedefind = this.result_sede.data.find(x => x.Id === id);
    this.SimuladorForm.controls.Direccion.setValue(sedefind.Nombre2);

    this.result_areaDeEstudio.loading = true
    // console.log("[SIMULACIÓN] Cargando Área",)
    const data: any = await this.mantenedor.getArea2(
      this.panel.PeriodoAdm.Id,
      this.SimuladorForm.get('Institucion').value,
      id
    ).toPromise().catch(error => { console.log('[SIMULACIÓN] Error: ', error); this.result_areaDeEstudio.loading = false; })
    // console.log("[SIMULACIÓN] Área Cargada", data.Result)
    this.result_areaDeEstudio.data = data.Result;
    this.result_areaDeEstudio.loading = false;
  }

  async ChangeCarrera(event: any) {
    this.SimuladorForm.controls.Modalidad.setValue('');
    this.SimuladorForm.controls.TipoPlan.setValue('');
    this.SimuladorForm.get("ViaAdmision").setValue('');

    const id = event.target.value;
    if (id === '') { return; }
    this.result_modalidad.loading = true;
    this.procesoMatriculaService.GetModalidad(this.SimuladorForm.controls.Institucion.value, this.SimuladorForm.controls.Sede.value, this.SimuladorForm.controls.Area.value
      , this.SimuladorForm.controls.Carrera.value, (this.SimuladorForm.controls.Jornada.value == 'D' ? 1 : 2)).subscribe(
        (data: any) => {
          if (data != '' && data != null) {
            var modalidadTipoPlan = data.split('|');
            this.SimuladorForm.controls.Modalidad.setValue(modalidadTipoPlan[0]);
            this.SimuladorForm.controls.TipoPlan.setValue(modalidadTipoPlan[1]);
            this.result_modalidad.loading = false;
          }
        },
        (err) => {
          this.result_modalidad.loading = false;
        },
        () => {
          this.result_modalidad.loading = false;
        }
      );

  }
  async ChangeArea(event: any) {
    this.cleanSelects(3);
    // console.log('[SIMULACIÓN] Change Area', event.target.value);
    const id = event.target.value;
    if (id === '' || this.SimuladorForm.get('Jornada').value === '' || this.SimuladorForm.get('TipoPrograma').value === '') { return; }
    this.result_carrera.loading = true
    const data: any = await this.mantenedor.getCarrera2(
      this.panel.PeriodoAdm.Id,
      this.SimuladorForm.get('Institucion').value,
      this.SimuladorForm.get('Sede').value,
      id,
      this.SimuladorForm.get('Jornada').value === 'D' ? '1' : '2',
      this.SimuladorForm.get('TipoPrograma').value
    ).toPromise().catch(error => { console.log('[SIMULACIÓN] Error: ', error); this.result_carrera.loading = false; })
    this.result_carrera.data = data.Result;
    this.result_carrera.loading = false
  }

  async ChangeJornada(event: any) {
    this.cleanSelects(4);
    const id = event.target.value;
    //|| this.SimuladorForm.get('TipoPrograma').value === ''
    //this.SimuladorForm.get('TipoPrograma').value


    if (this.SimuladorForm.get('Area').value === '' || this.SimuladorForm.get('Jornada').value === '') { return; }
    this.result_carrera.loading = true
    const data: any = await this.mantenedor.getCarrera2(
      this.panel.PeriodoAdm.Id,
      this.SimuladorForm.get('Institucion').value,
      this.SimuladorForm.get('Sede').value,
      this.SimuladorForm.get('Area').value,
      this.SimuladorForm.get('Jornada').value === 'D' ? '1' : '2',
      this.SimuladorForm.get('TipoPrograma').value
    ).toPromise().catch(error => { console.log('[SIMULACIÓN] Error: ', error); this.result_carrera.loading = false; })
    this.result_carrera.data = data.Result;
    this.result_carrera.loading = false
  }
  /********* SELECTS CHANGES *********/


  /********* SEND DATA *********/
  validateAllFormFields(formGroup: FormGroup) {         // {1}
    Object.keys(formGroup.controls).forEach(field => {  // {2}
      const control = formGroup.get(field);             // {3}
      if (control instanceof FormControl) {             // {4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        // {5}
        this.validateAllFormFields(control);            // {6}
      }
    });
  }

  handleErrorSimulacion() {
    this.LimpiarCargas();
    this.showBtnSimular = true;
    this.progress = false;
    this.errorAlSimular = true;
  }

  handleErrorViaIngreso() {
    this.LimpiarCargas();
    this.progress = false;
    this.enviando = false;
    this.errorViaIngreso = true;
    return;
  }

  handleErrorGuardar(msg: string = '', obj: any = null) {
    if (msg)
      console.log(`[DOCUMENTOS] ${msg}`, obj);
    this.progress = false;
    this.enviando = false;
    this.alerts.error('Ha ocurrido un error');
  }

  async CreaProceso() {
    const payloadIdProceso: AddUpdProcesoInput = new AddUpdProcesoInput(
      new Lookup(this.SimuladorForm.get('Institucion').value),
      new Lookup(this.SimuladorForm.get('Sede').value),
      new Lookup(this.userData.IdContacto),
      new Lookup(this.SimuladorForm.get('Carrera').value),
      this.panel.PeriodoAdm
    );
    this.procesoSimulacion = await this.procesoMatriculaService.CreaProceso(payloadIdProceso).toPromise().catch(err => console.log(err));
  }

  async CopagoMatrículayArancel() {
    const payloadCopagoMatriculayArancel = {
      Rut: this.userData.Rut,
      idProceso: this.procesoSimulacion.Id,
      codInstitucion: this.SimuladorForm.get('Institucion').value,
      codSede: this.SimuladorForm.get('Sede').value,
      codCarrera: this.SimuladorForm.get('Carrera').value,
      jornada: this.SimuladorForm.get('Jornada').value,
      tipoAlumno: 1, //TODO: viene desde getPanel, pero aún no está arriba, por default en 'NVO'. Luego cambiamos a 1
      agnoIngreso: this.panel.AnhoIngreso,
      agnoAcademico: this.panel.AnhoAcademico,
      semestreAcademico: this.panel.SemestreAcademico,
      tipoPrograma: this.SimuladorForm.get("TipoPlan").value == "Regular" ? "PR" : "PC",
      //ASDF
    }
    this.result_copagoMatriculayArancel.loading = true;
    this.result_copagoMatriculayArancel.data = await this.servicioUnificado.ObtieneValoresArancel(payloadCopagoMatriculayArancel).toPromise()
      .catch(err => {
        console.log(err);
        this.result_copagoMatriculayArancel.success = false;
        this.result_copagoMatriculayArancel.loading = false;
        this.result_copagoMatriculayArancel.loaded = true;
        return;
      });
    this.result_copagoMatriculayArancel.loading = false;
    this.result_copagoMatriculayArancel.loaded = true;
    this.result_copagoMatriculayArancel.success = this.result_copagoMatriculayArancel.data.Codigo === 1;
    if (!this.result_copagoMatriculayArancel.success) return this.result_copagoMatriculayArancel;

    this.result_copagoMatriculayArancel.totalAcumulado = this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].ValorAnualArancelLista

    // Guardar valor original matrícula
    this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].ValorAnualMatriculaListaOriginal = this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].ValorAnualMatriculaLista;
    console.log('[SIMULACIÓN] this.result_copagoMatriculayArancel', this.result_copagoMatriculayArancel)

    // Días pago semestres
    const dateSem1 = new Date(this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].FechaVctoCopagoArancelSemestre);
    const dateSem2 = new Date(this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].FechaVctoCopagoArancelSegundoSemestre);
    // this.result_copagoMatriculayArancel.diasPagoSem1 = [...Array(this.daysInMonth(dateSem1)).keys()].map(d => d + 1)
    // this.result_copagoMatriculayArancel.diasPagoSem2 = [...Array(this.daysInMonth(dateSem2)).keys()].map(d => d + 1)
    const diaPago = 25
    this.result_copagoMatriculayArancel.diasPagoSem1 = [diaPago];
    this.result_copagoMatriculayArancel.diasPagoSem2 = [diaPago];

    this.SimuladorForm.get("DiasPagoSem1").setValue(diaPago)
    this.SimuladorForm.get("DiasPagoSem2").setValue(diaPago)


    return this.result_copagoMatriculayArancel;
  }

  async ObtieneTipoIngreso() {
    const payload = {
      idProceso: this.procesoSimulacion.Id,
      codInstitucion: this.SimuladorForm.get('Institucion').value,
      CodSede: this.SimuladorForm.get('Sede').value,
      CodCarrera: this.SimuladorForm.get('Carrera').value,
      jornada: this.SimuladorForm.get('Jornada').value,
      agnoAcademico: this.panel.AnhoAcademico,
      semestreAcademico: this.panel.SemestreAcademico,
      rutAlumno: this.userData.Rut,
      //TODO:Por default 'NVO' a confirmar por Rodrigo.
      tipoAlumno: 'NVO',
      //TODO:Por default 'S' a confirmar por Rodrigo
      tieneLEM: 'S'
    }

    this.result_obtieneTipoIngreso.loading = true;
    this.result_obtieneTipoIngreso.data = await this.servicioUnificado.ObtieneTipoIngreso(payload).toPromise();
    this.result_obtieneTipoIngreso.loading = false;
    this.result_obtieneTipoIngreso.loaded = true;
    this.result_obtieneTipoIngreso.success = this.result_obtieneTipoIngreso.data.Codigo === 1;
    if (!this.result_obtieneTipoIngreso.success) return this.result_obtieneTipoIngreso;
    return this.result_obtieneTipoIngreso;
  }

  async ObtieneDescuento() {
    console.log('[CARRERA CONVOCADA] ObtieneDescuento', 1)
    const payloadDcto = {
      idProceso: this.procesoSimulacion.Id,
      CodInstitucion: this.SimuladorForm.get('Institucion').value,
      CodSede: this.SimuladorForm.get('Sede').value,
      CodCarrera: this.SimuladorForm.get('Carrera').value,
      Jornada: this.SimuladorForm.get('Jornada').value,
      Rut: this.userData.Rut,
      CodArancel: this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].CodArancel,
      agnoAcademico: this.panel.AnhoAcademico,
      // ViaAdmision: this.panel.ViaAdmision,
      ViaAdmision: this.result_obtieneTipoIngreso.data.RetornoDesdeApi[0].viaAdmision,
      //TODO: Obtener desde {{hostApi}}/ObtieneTipoIngreso
      CodTipoIngreso: (this.result_obtieneTipoIngreso.data
        && this.result_obtieneTipoIngreso.data.RetornoDesdeApi
        && this.result_obtieneTipoIngreso.data.RetornoDesdeApi.length > 0) ?
        this.result_obtieneTipoIngreso.data.RetornoDesdeApi[0].CodTipoIngreso : 'PSU'
    }
    console.log('[CARRERA CONVOCADA] ObtieneDescuento', 1.1, payloadDcto.ViaAdmision, payloadDcto.ViaAdmision === "" || payloadDcto.ViaAdmision === null)
    if (payloadDcto.ViaAdmision === "" || payloadDcto.ViaAdmision === null) {
      this.handleErrorViaIngreso();
      return;
    }
    console.log('[CARRERA CONVOCADA] ObtieneDescuento', 2)

    this.result_dcto.loading = true;
    this.result_dcto.data = await this.servicioUnificado.ObtieneDescuento(payloadDcto).toPromise().catch(err => {
      console.log(err);
      this.result_dcto.success = false;
      this.result_dcto.loading = false;
      this.result_dcto.loaded = true;
      return;
    });
    console.log('[CARRERA CONVOCADA] ObtieneDescuento', 3, this.result_dcto.data)
    this.result_dcto.loading = false;
    this.result_dcto.loaded = true;
    this.result_dcto.success = this.result_dcto.data.Codigo === 1;
    if (!this.result_dcto.success) return this.result_dcto;

    if (this.result_dcto.data.RetornoDesdeApi.length > 0) {
      if (this.result_dcto.data.RetornoDesdeApi[0].DATA && this.result_dcto.data.RetornoDesdeApi[0].DATA.length > 0) {
        this.result_dcto.ValorDcto = (this.result_dcto.data.RetornoDesdeApi[0].DATA[0].porcentajeDescuento / 100) * this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].ValorAnualMatriculaLista;
        this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].ValorAnualMatriculaLista = this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].ValorAnualMatriculaLista - this.result_dcto.ValorDcto
        const comentario = this.result_dcto.data.RetornoDesdeApi[0].DATA[0].comentario;
        this.result_dcto.mensaje = (comentario && comentario.length > 0) ? comentario : "Sin comentario";
      } else {
        this.result_dcto.ValorDcto = 0;
        this.result_dcto.mensaje = "Sin comentario";
        // this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].ValorAnualMatriculaLista = 0;
      }
    } else {
      this.result_dcto.mensaje = "Sin comentario";
      this.result_dcto.ValorDcto = 0;
      // this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].ValorAnualMatriculaLista = 0;
    }

    // Mensaje

    // const fechaHasta = this.result_dcto.data.RetornoDesdeApi[0].DATA[0].fechaHasta;


    return this.result_dcto;
  }

  async ObtieneBecaMineduc() {
    const payloadBecaMineduc = {
      idProceso: this.procesoSimulacion.Id,
      Rut: this.userData.Rut,
      CodigoArancel: this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].CodArancel // FV: Este parámetro se obtendrá desde el back
    };
    this.result_becaMineduc.loading = true;
    this.result_becaMineduc.data = await this.servicioUnificado.ObtieneBecasMineduc(payloadBecaMineduc).toPromise()
      .catch(err => {
        console.log(err);
        this.handleErrorSimulacion();
        this.result_becaMineduc.loading = false;
        this.result_becaMineduc.loaded = true;
        return;
      });
    this.result_becaMineduc.loading = false;
    this.result_becaMineduc.loaded = true;
    this.result_becaMineduc.success = this.result_becaMineduc.data.Codigo === 1;
    if (!this.result_becaMineduc.success) return this.result_becaMineduc;

    this.result_becaMineduc.tieneDatosValidos = this.result_becaMineduc.data.ListBecaMineduc && this.result_becaMineduc.data.ListBecaMineduc.length > 0
    if (!this.result_becaMineduc.tieneDatosValidos) {
      this.result_becaMineduc.data = { ListBecaMineduc: [{ Monto: 0 }] }
    }

    this.result_becaMineduc.totalAcumulado = this.result_copagoMatriculayArancel.totalAcumulado - this.result_becaMineduc.data.ListBecaMineduc[0].Monto
    console.log('[SIMULACIÓN] this.result_becaMineduc', this.result_becaMineduc)
    // if (!this.result_becaMineduc.success) {
    //   this.handleErrorSimulacion();
    //   return;
    // }

    return this.result_becaMineduc;
  }

  async ObtieneBecaPSU() {
    const payloadBecaPsu = {
      idProceso: this.procesoSimulacion.Id,
      Rut: this.userData.Rut,
      CodArancel: this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].CodArancel,
      AgnoPsu: this.notasData.AnhoPsu,
      PromedioPsu: this.notasData.PuntajePromedioPsu
    }
    this.result_becaPSU.loading = true;
    this.result_becaPSU.data = await this.servicioUnificado.ObtieneBecaPsu(payloadBecaPsu).toPromise()
      .catch(err => {
        console.log(err);
        this.handleErrorSimulacion();
        this.result_becaPSU.loading = false;
        this.result_becaPSU.loaded = true;
        return;
      });
    this.result_becaPSU.loading = false;
    this.result_becaPSU.loaded = true;
    console.log('[SIMULACIÓN] BECA PSU pre success...')
    this.result_becaPSU.success = this.result_becaPSU.data.Codigo === 1;
    if (!this.result_becaPSU.success) return this.result_becaPSU;
    console.log('[SIMULACIÓN] BECA PSU success')
    console.log('[SIMULACIÓN] BECA PSU this.result_becaPSU', this.result_becaPSU)

    // const _procesoSimulacionPSU: any = await this.servicioUnificado.GetProceso(this.procesoSimulacion.Id).toPromise().catch(err => console.log(err));
    // this.result_becaPSU.porcentaje = _procesoSimulacionPSU.Porcentaje;
    this.result_becaPSU.tieneDatosValidos = this.result_becaPSU.data.RetornoDesdeApi && this.result_becaPSU.data.RetornoDesdeApi.length > 0
    console.log('[SIMULACIÓN] BECA PSU this.result_becaPSU.tieneDatosValidos', this.result_becaPSU.tieneDatosValidos)
    if (!this.result_becaPSU.tieneDatosValidos) {
      this.result_becaPSU.data = { RetornoDesdeApi: [{ porcentaje: 0 }] }
    }

    this.result_becaPSU.porcentaje = this.result_becaPSU.data.RetornoDesdeApi[0].porcentaje;
    this.result_becaPSU.valorDcto = (this.result_becaPSU.porcentaje / 100) * this.result_becaMineduc.totalAcumulado;
    this.result_becaPSU.totalAcumulado = this.result_becaMineduc.totalAcumulado - this.result_becaPSU.valorDcto

    return this.result_becaPSU;
  }

  async DescuentoSantoTomas() {
    this.result_becaSantoTomas.loading = true;
    this.result_becaSantoTomas.data = this.result_dcto.data;
    this.result_becaSantoTomas.loading = false;
    this.result_becaSantoTomas.loaded = true;
    this.result_becaSantoTomas.success = this.result_becaSantoTomas.data.Codigo === 1;
    if (!this.result_becaSantoTomas.success) return this.result_becaSantoTomas;

    this.result_becaSantoTomas.porcentaje = this.result_becaSantoTomas.data.RetornoDesdeApi[0].DATA[0].porcentajeDescuento / 100;
    this.result_becaSantoTomas.valorDcto = this.result_becaSantoTomas.porcentaje * this.result_becaPSU.totalAcumulado;
    this.result_becaSantoTomas.totalAcumulado = this.result_becaPSU.totalAcumulado - this.result_becaSantoTomas.valorDcto
    // this.result_becaSantoTomas.totalAcumulado = this.result_becaPSU.totalAcumulado - this.result_becaSantoTomas.data.RetornoDesdeApi[0].Monto
    console.log('[SIMULACIÓN] this.result_becaSantoTomas', this.result_becaSantoTomas)
    // if (!this.result_becaSantoTomas.success) {
    //   this.handleErrorSimulacion();
    //   return;
    // }
    return this.result_becaSantoTomas;
    //result_becaSantoTomas.data.RetornoDesdeApi[0].Monto
  }

  async ObtieneBecaCAE(_procesoSimulacionPSU: any) {
    const payloadBecaCae = {
      idProceso: this.procesoSimulacion.Id,
      Rut: this.userData.Rut,
      CodArancel: this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].CodArancel,
      PromedioNem: this.notasPSUData.UbicacionNem
    };
    this.result_becaCAE.loading = true;
    this.result_becaCAE.data = await this.servicioUnificado.ObtieneBecaCAE(payloadBecaCae).toPromise()
      .catch(err => {
        console.log(err);
        this.handleErrorSimulacion();
        this.result_becaCAE.loading = false;
        this.result_becaCAE.loaded = true;
        return;
      });
    this.result_becaCAE.loading = false;
    this.result_becaCAE.loaded = true;
    this.result_becaCAE.success = this.result_becaCAE.data.Codigo === 1;
    if (!this.result_becaCAE.success) return this.result_becaCAE;

    if (this.result_becaCAE.data.RetornoDesdeApi.length > 0)
      this.result_becaCAE.MontoCAE = this.result_becaCAE.data.RetornoDesdeApi[0].MontoCAE;

    this.result_becaCAE.tieneDatosValidos = this.result_becaCAE.MontoCAE > 0

    return this.result_becaCAE;
  }

  LimpiarCargas(limpiarCarrera: boolean = false) {
    if (limpiarCarrera)
      this.SimuladorForm.get("Carrera").setValue('');
    this.pagoAlContado = false;
    this.SimuladorForm.get("UsarMontoCAE").setValue(false);
    this.SimuladorForm.get("MontoAlDia").setValue(0);
    this.SimuladorForm.get("PagoAlContado").setValue(this.pagoAlContado);

    this.result_obtieneTipoIngreso.loading = false; this.result_obtieneTipoIngreso.loaded = false;
    this.result_copagoMatriculayArancel.loading = false; this.result_copagoMatriculayArancel.loaded = false;
    this.result_dcto.loading = false; this.result_dcto.loaded = false;
    this.result_becaMineduc.loading = false; this.result_becaMineduc.loaded = false;
    this.result_becaPSU.loading = false; this.result_becaPSU.loaded = false;
    this.result_becaSantoTomas.loading = false; this.result_becaSantoTomas.loaded = false;
    this.result_becaCAE.loading = false; this.result_becaCAE.loaded = false;
    this.result_pagoContado.loading = false; this.result_pagoContado.loaded = false;
    this.result_pagoAlDia.loading = false; this.result_pagoAlDia.loaded = false;
    this.result_pagoColegiaturaPlazo.loading = false; this.result_pagoColegiaturaPlazo.loaded = false;
    this.progress = false;
    this.todoCargado = false;
    this.errorAlSimular = false;
    this.errorViaIngreso = false;
  }

  async Simular() {
    try {
      this.showBtnSimular = false

      // TODO: Corregir para Admisión Centralizada
      // FIXME: Remuevo esta validación ya que los datos deberían estar cargados
      // this.validateAllFormFields(this.SimuladorForm);
      console.log(this.SimuladorForm.value)
      if (/*this.SimuladorForm.valid*/ true) {

        // Limpiar
        this.LimpiarCargas();

        // Set valor iniciales
        this.progress = true;
        // this.result_copagoMatriculayArancel.loaded = false;
        // this.result_dcto.loaded = false;
        // this.result_becaMineduc.loaded = false;
        // this.result_becaPSU.loaded = false;
        // this.result_becaSantoTomas.loaded = false;
        // this.result_becaCAE.loaded = false;
        // this.result_pagoAlDia.loaded = false;
        // this.result_pagoColegiaturaPlazo.loaded = false;

        const waitMillisecondsUntilFocus = 1500;
        const focusChange = false;
        const focusChangeToBottom = true;
        this.result_copagoMatriculayArancel.loading = true; // FIX para que se vea cargando esta parte completa

        // Foco en grupo Copago
        if (focusChange) {
          setTimeout(() => {
            try { $('html, body').animate({ scrollTop: $('#divCopago').offset().top }, 'slow'); } catch { }
          }, waitMillisecondsUntilFocus);
        }

        if (focusChangeToBottom) this.goToBottomDiv();

        // Cargar desde Input
        if (this.IdProcesoActual.length === 0) {
          // Obtener IdProceso
          await this.CreaProceso();
        }

        // Copago Matrícula y Arancel Alumno
        const resultadoCopago = await this.CopagoMatrículayArancel();
        if (!resultadoCopago.success) {
          this.handleErrorSimulacion();
          return;
        }
        if (focusChangeToBottom) this.goToBottomDiv();

        // Obtiene Descuento
        this.result_dcto.loading = true // FIX para que se vea cargando esta parte completa
        const resultadoObtieneTipoIngreso = await this.ObtieneTipoIngreso();  // Se llama primero ya que se necesitan unos valores de acá
        if (!resultadoObtieneTipoIngreso.success) {
          console.log('[SIMULACIÓN] FALLA AL OBTENER TIPO INGRESO', resultadoObtieneTipoIngreso.data)
          this.handleErrorSimulacion();
          return;
        }

        this.SimuladorForm.get('ViaAdmision').setValue(this.result_obtieneTipoIngreso.data.RetornoDesdeApi[0].viaAdmision);
        const resultadoDescuento = await this.ObtieneDescuento();
        console.log('[CARRERA CONVOCADA] resultadoDescuento', resultadoDescuento)
        if (!resultadoDescuento.success) {
          this.handleErrorSimulacion();
          return;
        }
        if (focusChangeToBottom) this.goToBottomDiv();

        // Foco en grupo Becas
        if (focusChange) {
          this.result_becaMineduc.loading = true;
          setTimeout(() => {
            try { $('html, body').animate({ scrollTop: $('#divBecas').offset().top }, 'slow'); } catch { }
          }, waitMillisecondsUntilFocus);
        }

        // Obtiene Becas Mineduc
        const resultadoBecaMineduc = await this.ObtieneBecaMineduc();
        if (!resultadoBecaMineduc.success) {
          this.handleErrorSimulacion();
          return;
        }
        if (focusChangeToBottom) this.goToBottomDiv();

        // Beca PSU
        const resultadoBecaPSU = await this.ObtieneBecaPSU();
        if (!resultadoBecaPSU.success) {
          console.log('[SIMULACIÓN] BECA PSU', resultadoBecaPSU);
          this.handleErrorSimulacion();
          return;
        }
        if (focusChangeToBottom) this.goToBottomDiv();
        // const _procesoSimulacionPSU: any = await this.servicioUnificado.GetProceso(this.procesoSimulacion.Id).toPromise().catch(err => console.log(err));
        // this.result_becaPSU.porcentaje = _procesoSimulacionPSU.Porcentaje;
        // this.result_becaPSU.valorDcto = (this.result_becaPSU.porcentaje / 100) * this.result_becaMineduc.totalAcumulado;
        // this.result_becaPSU.totalAcumulado = this.result_becaMineduc.totalAcumulado - this.result_becaPSU.valorDcto




        // Beca o Descuento Santo Tomás
        // await this.DescuentoSantoTomas();
        this.result_becaSantoTomas.totalAcumulado = this.result_becaPSU.totalAcumulado;


        // CAE
        this.result_becaCAE.loading = true; // FIX para que se vea cargando esta parte completa
        const _procesoSimulacionPSU: any = await this.procesoMatriculaService.GetProceso(this.procesoSimulacion.Id).toPromise().catch(err => console.log(err));
        const resultadoBecaCAE = await this.ObtieneBecaCAE(_procesoSimulacionPSU);
        if (!resultadoBecaCAE.success) {
          this.handleErrorSimulacion();
          return;
        }
        this.calcularCAE();

        console.log('[SIMULACIÓN] this.result_becaCAE', this.result_becaCAE)
        if (!this.result_becaCAE.success) {
          this.handleErrorSimulacion();
          return;
        }
        if (focusChangeToBottom) this.goToBottomDiv();

        // Calcular Pago Contado
        this.calcularPagoContado();

        // Pago Al Día					->		?
        this.result_pagoAlDia.success = true;
        this.result_pagoAlDia.loaded = true;
        this.calcularPagoAlDia();
        if (focusChangeToBottom) this.goToBottomDiv();

        // Foco en grupo Pagos
        if (focusChange) {
          // this.result_pagoAlDia.loading = true; // FIX para que se vea cargando esta parte completa
          setTimeout(() => {
            try { $('html, body').animate({ scrollTop: $('#divPagos').offset().top }, 'slow'); } catch { }
          }, waitMillisecondsUntilFocus);
        }

        // // Pagar todo al contado
        // this.calcularPagoContado();

        // Pago de Colegiatura a Plazo
        this.calcularColegiaturaAPlazo();
        if (focusChangeToBottom) this.goToBottomDiv();


        this.progress = false;
        this.todoCargado = true;

        // Foco en grupo Pagos
        if (focusChange) {
          setTimeout(() => {
            try { $('html, body').animate({ scrollTop: $('#divBotones').offset().top }, 'slow'); } catch { }
          }, waitMillisecondsUntilFocus);
        }

      } else {
        console.log(this.SimuladorForm)
      }
      this.showBtnSimular = false
    } catch (error) {
      this.showBtnSimular = true
      if (!this.errorViaIngreso)
        this.handleErrorSimulacion();
      console.log('[SIMULACIÓN] Error al simular', error)
    }
  }

  crearListenerFormulario() {
    this.pagoAlContado = this.SimuladorForm.get('PagoAlContado').value;
    this.SimuladorForm.valueChanges.subscribe(valor => {
      // console.log('[SIMULACIÓN] cambio el SimuladorForm', this.SimuladorForm)
      if (this.todoCargado)
        this.recalcular();
    })
  }

  calcularCAE() {
    this.result_becaCAE.totalAcumulado = this.result_becaSantoTomas.totalAcumulado;
    if (this.SimuladorForm.get('UsarMontoCAE').value && Number.parseFloat(this.SimuladorForm.get('MontoAUtilizar').value) > 0)
      this.result_becaCAE.totalAcumulado = this.result_becaSantoTomas.totalAcumulado - this.SimuladorForm.get('MontoAUtilizar').value;
    else if (!this.SimuladorForm.get('UsarMontoCAE').value)
      this.SimuladorForm.get('MontoAUtilizar').setValue(0);
  }

  changeUtilizarCae() {
    var valorAUtilizar = 0;
    if (this.result_becaCAE.MontoCAE > this.result_becaSantoTomas.totalAcumulado) {
      valorAUtilizar = this.result_becaSantoTomas.totalAcumulado;
    } else {
      valorAUtilizar = this.result_becaCAE.MontoCAE
    }
    if (this.SimuladorForm.get('UsarMontoCAE').value) {
      this.SimuladorForm.get('MontoAUtilizar').setValue(valorAUtilizar);
      this.recalcular();
    }
  }

  changeMontoUtilizar() {
    if (this.SimuladorForm.get('UsarMontoCAE').value) {
      var valorAUtilizar = 0;

      if (this.result_becaCAE.MontoCAE > this.result_becaSantoTomas.totalAcumulado) {
        valorAUtilizar = this.result_becaSantoTomas.totalAcumulado;
      } else {
        valorAUtilizar = this.result_becaCAE.MontoCAE
      }
      if (Number.parseFloat(this.SimuladorForm.get('MontoAUtilizar').value) < 200000 || Number.parseFloat(this.SimuladorForm.get('MontoAUtilizar').value) > valorAUtilizar) {
        this.SimuladorForm.get('MontoAUtilizar').setValue(200000);
      }
      if (this.todoCargado)
        this.recalcular();
    }
  }

  calcularPagoContado() {
    console.log('[SIMULACIÓN] calcularPagoContado', this.result_copagoMatriculayArancel.data)
    console.log('[SIMULACIÓN] calcularPagoContado', this.result_dcto)
    console.log('[SIMULACIÓN] calcularPagoContado', this.result_becaCAE.totalAcumulado)
    console.log('[SIMULACIÓN] calcularPagoContado', this.result_pagoContado.MontoDcto)
    const { DoctoProntoPago } = this.panel;
    this.result_pagoContado.MatriculaADoc = this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].ValorAnualMatriculaLista; //Original;
    this.result_pagoContado.MontoDcto = Math.round((DoctoProntoPago / 100) * this.result_becaCAE.totalAcumulado); //  this.result_dcto.ValorDcto;
    console.log('[SIMULACIÓN] calcularPagoContado', this.result_pagoContado.MontoDcto)
    this.result_pagoContado.totalAcumulado = this.result_becaCAE.totalAcumulado - this.result_pagoContado.MontoDcto;
  }

  calcularPagoAlDia() {
    const montoDia = this.SimuladorForm.get('MontoAlDia').value;
    const totalMatricula = this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].ValorAnualMatriculaLista;
    // const totalAcumulado = this.result_pagoContado.totalAcumulado; //this.result_becaCAE.totalAcumulado;
    const totalAcumulado = this.result_becaCAE.totalAcumulado;

    this.result_pagoAlDia.data.AbonoMatricula = montoDia;
    this.result_pagoAlDia.FechaDocumento = new Date();
    this.result_pagoAlDia.data.AbonoColegiatura = 0;
    this.result_pagoAlDia.data.ColegDoc = totalAcumulado;
    if (montoDia >= totalMatricula) {
      this.result_pagoAlDia.data.AbonoMatricula = totalMatricula;
      this.result_pagoAlDia.data.AbonoColegiatura = Math.abs(this.result_pagoAlDia.data.AbonoMatricula - montoDia);
      this.result_pagoAlDia.data.ColegDoc = totalAcumulado - this.result_pagoAlDia.data.AbonoColegiatura;
    }
    this.result_pagoAlDia.data.MatriculaDoc = Math.abs(this.result_pagoAlDia.data.AbonoMatricula - totalMatricula);
  }

  calcularColegiaturaAPlazo() {
    this.result_pagoColegiaturaPlazo.success = true
    this.result_pagoColegiaturaPlazo.loaded = true

    const cuotasSem1 = this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].cuotasCopagoArancelSemestre1;
    const cuotasSem2 = this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].cuotasCopagoArancelSemestre2;
    const totalCuotas = cuotasSem1 + cuotasSem2;
    // const totalADividirCuotas = (this.result_pagoAlDia.data.ColegDoc + this.result_pagoAlDia.data.MatriculaDoc) / totalCuotas;
    const totalADividirCuotas = (this.result_pagoAlDia.data.ColegDoc) / totalCuotas;
    this.result_pagoColegiaturaPlazo.data.MontoSemestre1 = totalADividirCuotas * cuotasSem1; // / cuotasSem1;
    this.result_pagoColegiaturaPlazo.data.MontoSemestre2 = totalADividirCuotas * cuotasSem2; // / cuotasSem2;
  }

  recalcular() {
    console.log("[SIMULACIÓN] Recalculando...")
    this.pagoAlContado = this.SimuladorForm.get('PagoAlContado').value;
    this.calcularCAE();
    this.calcularPagoAlDia();
    this.calcularPagoContado();
    this.calcularColegiaturaAPlazo();
  }

  fechaPagoChange(semestre: number) {
    let fechaPago = 0;
    if (semestre === 1) {
      fechaPago = this.SimuladorForm.get('DiasPagoSem1').value;
      this.SimuladorForm.get("DiasPagoSem2").setValue(fechaPago);
    }
    else {
      fechaPago = this.SimuladorForm.get('DiasPagoSem2').value;
      this.SimuladorForm.get("DiasPagoSem1").setValue(fechaPago);
    }
  }

  handleStopEnvio() {
    this.enviando = false;
    this.closeModalBloqueoFinanciero()
  }

  goToBottomDiv() {
    const waitMillisecondsUntilFocus = 1500;
    setTimeout(() => {
      try { $('html, body').animate({ scrollTop: $('#divBottom').offset().top }, 'slow'); } catch { }
    }, waitMillisecondsUntilFocus);
  }


  async guardar(continuar: boolean = false) {
    try {
      this.enviando = true;

      const payload: UpdProcesoInput = new UpdProcesoInput(
        new Lookup(this.SimuladorForm.get('Institucion').value),
        new Lookup(this.SimuladorForm.get('Sede').value),
        new Lookup(this.userData.IdContacto),
        new Lookup(this.SimuladorForm.get('Carrera').value),
        this.panel.PeriodoAdm
      );

      payload.Area = new Lookup(this.SimuladorForm.get('Area').value)
      payload.Jornada = new OptionSet(this.SimuladorForm.get('Jornada').value)

      payload.IdProceso = this.procesoSimulacion.Id;

      // payload.FasePortal.Name = "mbo_faseportalweb"
      // payload.FasePortal.Value = "4"

      // Matrícula
      payload.CopagoMatricula = this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].ValorAnualMatriculaListaOriginal;
      payload.CopagoMatricula1 = this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].ValorSemestreMatriculaLista;
      payload.CopagoMatricula2 = this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].ValorSemestreDosMatriculaLista;

      // Dcto Matricula
      if (this.result_dcto.data.RetornoDesdeApi.length > 0)
        payload.ProcentajeDesMatricula = this.result_dcto.data.RetornoDesdeApi[0].DATA[0].porcentajeDescuento;
      else
        payload.ProcentajeDesMatricula = null;
      payload.ValorDescMatricula = this.result_dcto.ValorDcto;
      payload.CopagoMatriculaTotal = this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].ValorAnualMatriculaLista;

      // Arancel
      payload.CopagoArenceles = this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].ValorAnualArancelLista;
      payload.CopagoAranceles1 = this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].ValorSemestreArancelLista;
      payload.CopagoAranceles2 = this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].ValorSemestreDosArancelLista;

      // Mineduc
      payload.MontoBecaAsignable = this.result_becaMineduc.data.ListBecaMineduc[0].Monto;
      payload.MontoBeca = this.result_becaMineduc.data.ListBecaMineduc[0].Monto;
      payload.ValorColegAPagar = this.result_becaMineduc.totalAcumulado;

      // PSU
      payload.Porcentaje = this.result_becaPSU.porcentaje;
      payload.ValorDescuento = this.result_becaPSU.valorDcto;
      payload.ValorColegAPagar1 = this.result_becaPSU.totalAcumulado;

      // // Sto Tomas
      // payload.PorcentajeDescuentoBecode = "";
      // payload.ValorDescuentoBecode = "";
      // payload.ValorColegAPagar2 = "";

      // CAE
      payload.MontoCae = this.result_becaCAE.MontoCAE;
      payload.DeseaUsarCredito = this.SimuladorForm.get('UsarMontoCAE').value ? "SI" : "NO";
      payload.MontoAUtilizar = this.SimuladorForm.get('MontoAUtilizar').value;
      payload.ColegaDoc = this.result_becaCAE.totalAcumulado;

      payload.MontoMatriculaPP = this.result_pagoContado.MatriculaADoc;
      payload.DescuentoProntoPago = this.result_pagoContado.MontoDcto;
      payload.MontoColegiaturaPP = this.result_pagoContado.totalAcumulado;

      payload.CheckProntoPago = this.pagoAlContado;

      if (!this.pagoAlContado) {
        // Pago al dia
        payload.MontoAlDia = this.SimuladorForm.get('MontoAlDia').value;
        payload.FechaDocumento = this.result_pagoAlDia.FechaDocumento.toISOString().split('T')[0];
        payload.AbonoMatricula = this.result_pagoAlDia.data.AbonoMatricula;
        payload.AbonoColegiatura = this.result_pagoAlDia.data.AbonoColegiatura;
        payload.MatriculaADoc = this.result_pagoAlDia.data.MatriculaDoc;
        payload.ColegaDoc1 = this.result_pagoAlDia.data.ColegDoc;

        // Pago Colegiatura Plazo
        payload.Total1Sem = this.result_pagoColegiaturaPlazo.data.MontoSemestre1;
        payload.Cuotas1 = this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].cuotasCopagoArancelSemestre1;
        payload.Total2Sem = this.result_pagoColegiaturaPlazo.data.MontoSemestre2;
        payload.Cuotas2 = this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].cuotasCopagoArancelSemestre2;
        payload.TipoDePago1 = "Cuota";
        payload.TipoDePago2 = "Cuota";
        // payload.FechaPago1 = formatDate(this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].FechaVctoCopagoArancelSemestre, 'yyyy-MM-dd', "es-CL");
        // payload.FechaPago2 = formatDate(this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].FechaVctoCopagoArancelSegundoSemestre, 'yyyy-MM-dd', "'es-CL");
        // payload.FechaPago1 = this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].FechaVctoCopagoArancelSemestre.slice(0, 10);
        // payload.FechaPago2 = this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].FechaVctoCopagoArancelSegundoSemestre.slice(0, 10);
        payload.FechaPago1 = this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].FechaVctoCopagoArancelSemestre.slice(0, 8) + this.SimuladorForm.get('DiasPagoSem1').value.toString().padStart(2, '0');
        payload.FechaPago2 = this.result_copagoMatriculayArancel.data.RetornoDesdeApi[0].FechaVctoCopagoArancelSegundoSemestre.slice(0, 8) + this.SimuladorForm.get('DiasPagoSem2').value.toString().padStart(2, '0');
      }
      const data = await this.procesoMatriculaService.guardarSimulacion(payload).toPromise().catch(err => console.log(err));
      console.log('[SIMULACIÓN] guardarSimulacion', data)
      // this.handleStopEnvio();


      // // 1st Verificar bloqueo financiero
      const bloqueoFinanciero = this.userData.BloqueoFinanciero;
      console.log('[SIMULACIÓN] bloqueoFinanciero', bloqueoFinanciero);

      // // 1 => SI => Modal
      //if (GlobalVariable.bloqueoFinanciero) {

        if (bloqueoFinanciero) {
          this.openModalBloqueoFinanciero();
          setTimeout(() => {
            this.closeModalBloqueoFinanciero()
          }, 6000)
          // this.handleStopEnvio();
          // return;
        }
      //}

      let opResult = true;
      const resultExisteMatricula: any = await this.servicioUnificado.ValidaExisteMatricula({
        idProceso: this.procesoSimulacion.Id
      }).toPromise()
        .catch(err => {
          console.log(err);
          this.handleErrorGuardar('Existe Matricula', err);
          opResult = false;
          // this.result_becaCAE.loading = false;
          // this.result_becaCAE.loaded = true;
          return;
        });
      if (!opResult) {
        this.handleErrorGuardar('Existe Matricula');
        return;
      }

      // 1 => NO => 2nd Verificar bloqueo académico
      const resultBloqueoAcademico: any = await this.servicioUnificado.ObtieneSituacionAcademica({
        idProceso: this.procesoSimulacion.Id,
        Rut: this.userData.Rut,
      }).toPromise()
        .catch(err => {
          console.log(err);
          this.handleErrorGuardar('bloqueo académico', err);
          opResult = false;
          // this.result_becaCAE.loading = false;
          // this.result_becaCAE.loaded = true;
          return;
        });
      if (!opResult || resultBloqueoAcademico.Codigo !== 1) {
        this.handleErrorGuardar('bloqueo académico');
        return;
      }
      //TODO: Revisar validación
      //const bloqueoAcademico: boolean = resultBloqueoAcademico.RetornoDesdeApi[0].Mensaje === "1|";
      const bloqueoAcademico: boolean = resultBloqueoAcademico.RetornoDesdeApi[0].Mensaje.startsWith("1|");

      if (resultExisteMatricula.Result.Id != "00000000-0000-0000-0000-000000000000") {
        this.openModalExisteMatricula();
        this.handleStopEnvio();
        return;
      }

      // 2 => Tiene bloqueo ("1|") => Modal con botones
      if (bloqueoAcademico) {
        this.openModalBloqueoAcademico();
        this.handleStopEnvio();
        if (GlobalVariable.bloqueoAcademico) {
          return; // 
        }
      }

      this.handleStopEnvio();

      // 2 => No tiene bloqueo ("0|") => Continuar
      // Cambiar de fase solo si está ok
      if (continuar) {
        this.enviando = true;
        try {
          this.panel.Institucion = new Lookup(payload.Institucion.Id, this.result_institucion.data.filter(x => x.FK === payload.Institucion.Id)[0].Nombre);
          this.panel.Sede = new Lookup(payload.Sede.Id, this.result_sede.data.filter(x => x.Id == payload.Sede.Id)[0].Nombre);
          this.panel.Carrera = new Lookup(payload.Carrera.Id, this.result_carrera.data.filter(x => x.Id == payload.Carrera.Id)[0].Nombre);
          this.panel.Jornada = new OptionSet(payload.Jornada.Value, this.result_jornada.data.filter(x => x.Id == payload.Jornada.Value)[0].Nombre);
          this.panel.TipoIngreso = new Lookup('', this.result_obtieneTipoIngreso.data.RetornoDesdeApi[0].CodTipoIngreso);
          this.panel.ViaAdmision = this.result_obtieneTipoIngreso.data.RetornoDesdeApi[0].viaAdmision;

          // setTimeout(() => {
          //Esperar a que se cierre el modal
          // this.Fase.emit('4');
          // this.faseService.fase$.emit('4');

          // TODO: CAmbiar a fase 4
          // Cambiar a fase 4
          this.procesoMatriculaService.setFase(this.procesoSimulacion.Id, '4').subscribe(
            (data) => {
              console.log(data);
              this.closeModalBloqueoFinanciero()
              this.Fase.emit('4');
              this.faseService.fase$.emit('4');
              this.enviando = false;
            },
            (err) => { console.log(err) },
            () => {
              this.enviando = false;
            },
          );
        } catch {
          this.closeModalBloqueoFinanciero()
        }
      }

    } catch (error) {
      this.handleStopEnvio();
      console.log('[SIMULACIÓN] Error al enviar data', error); // TODO: Donde poner mensaje de error?
    }
    // Está dentro del bloque try
    // if (continuar) {
    //   this.Fase.emit('4');
    //   this.faseService.fase$.emit('4');
    // }
    /********* SEND DATA *********/
  }

  /********* SEND DATA *********/

  /********* Modales *********/
  openModalBloqueoFinanciero() {
    $('#bloqueoFinancieroModal').modal('show');
  }

  closeModalBloqueoFinanciero() {
    $('#bloqueoFinancieroModal').modal('hide');
  }

  openModalBloqueoAcademico() {
    $('#bloqueoAcademicoModal').modal('show');
  }

  openModalInfoESign(payload: any) {
    $('#infoCorreoESign').modal('show');
  }

  openModalExisteMatricula() {
    $('#modalExisteMatri').modal('show');
  }
  /********* Modales *********/

  /********* Operaciones de Modales *********/
  seleccionarOtraCarrera() {
    console.log('[SIMULACIÓN] seleccionarOtraCarrera')
    this.LimpiarCargas(true);
    $('#bloqueoAcademicoModal').modal('hide');
    // $('#bloqueoVacantesModal').modal('hide');
  }

  async contactar() {
    console.log('[SIMULACIÓN] contactar')
    await this.procesoMatriculaService.listaEspera(this.procesoSimulacion.Id)
      .toPromise()
      .catch(err => {
        this.alerts.error('Ocurrió un error, intente nuevamente', 'Atención');
        console.log(err);
      });
    this.router.navigateByUrl('/inicio');
    $('#bloqueoAcademicoModal').modal('hide');
    // $('#bloqueoVacantesModal').modal('hide');
  }

  cancelarPostulacion() {
    console.log('[SIMULACIÓN] cancelarPostulacion')
    this.procesoMatriculaService.desactivaSimulacion(this.procesoSimulacion.Id).subscribe(
      (data: any) => {
        this.alerts.success('Proceso cancelado');
        this.router.navigateByUrl('/inicio');
        this.procesosActivosService.procesosActivos$.emit('LOAD_PROCESOS');
      },
      (err) => {
        this.alerts.error('Ocurrió un error, intente nuevamente', 'Atención');
        console.log(err)
      },
      () => {
        $('#bloqueoAcademicoModal').modal('hide');
        // $('#bloqueoVacantesModal').modal('hide');
      }
    )
  }
  /********* Operaciones de Modales *********/


  // /********* TEST MODAL (DEV) *********/
  // openModal_InfoCorreoESign() {
  //   $('#infoCorreoESign').modal('show');
  // }
  // /********* TEST MODAL (DEV) *********/

}
